import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgFile({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 4H8a1 1 0 00-1 1v14a1 1 0 001 1h8a1 1 0 001-1v-9h-3a3 3 0 01-3-3V4zm4.586 4L13 5.414V7a1 1 0 001 1h1.586zM8 2h4.414L19 8.586V19a3 3 0 01-3 3H8a3 3 0 01-3-3V5a3 3 0 013-3z"
        fill={color}
      />
    </svg>
  )
}

export default SvgFile
